import { render, staticRenderFns } from "./rolePermission.vue?vue&type=template&id=7baee5fa&"
import script from "./rolePermission.vue?vue&type=script&lang=js&"
export * from "./rolePermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "rolePermission.vue"
export default component.exports